import React from 'react';
import {Edit, List} from 'components';
import {useNamedSelector} from 'helpers';

export function HealthGoalActions() {
  const goal = useNamedSelector('clarity.goals', { category: 'health-&-fitness' });
  const activities = useNamedSelector('clarity.activities', { category: 'health-&-fitness' });
  return (
    <List tiny-gutter>
      <p>Look at your answers from the previous page and set yourself one specific health goal. It should be something big, something that would make a big difference in your life.</p>
      <Edit value={goal.name} setValue={goal.update} />
      <List.Title>What are one or two actions you can take over the next month that will set you on the path to achieving your health goal? Schedule that action and commit to doing it.</List.Title>
      <Edit name="0" value={activities.first} setValue={activities.update} />
      <Edit name="1" value={activities.second} setValue={activities.update} />
    </List>
  );
}
